module.exports = {
    //登录页
    login: {
        userName: '用户名',
        passWord: '密码',
        remember: '记住密码',
        sign: '登录'
    },
    //登录页
    loginPlaceholder: {
        userName: '请输入工号或姓名',
        passWord: '请输入密码'
    },
    //头部设置
    ticks: {
        isPay: '待付款订单',
        isAddress: '待发货订单',
        attension: '产品库存警告',
        localMessage: '站内信',
        payMessage: '订单信息',
        remid: '更改密码',
        layOuts: '退出'
    },
    //侧边栏
    nav: {
        goos: {
            title: '订单',
            management: '订单管理',
            Waybill: '运单管理',
            Courier: '导入快递'
        }
    }
}

